function revealColumnSections(scope = document) {
  const sections = scope.querySelectorAll('.column-section--reveal:not(.column-section--ready)');
  if (!sections.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    sections.forEach((section) => section.classList.add('column-section--ready'));
    return;
  }

  sections.forEach((section) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        section.classList.add('column-section--ready');
      });
    });
  });
}

function preloadColumnImages(scope = document) {
  scope.querySelectorAll('.column-section--reveal .column-grid img').forEach((image) => {
    if (image.complete) return;
    if (image.loading === 'lazy') image.loading = 'eager';

    const preload = new Image();
    if (image.sizes) preload.sizes = image.sizes;
    if (image.srcset) preload.srcset = image.srcset;
    preload.src = image.currentSrc || image.src;
  });
}

function initMainBlogReveal(scope = document) {
  preloadColumnImages(scope);
  revealColumnSections(scope);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initMainBlogReveal());
} else {
  initMainBlogReveal();
}

window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  document.querySelectorAll('.column-section--reveal').forEach((section) => {
    section.classList.add('column-section--ready');
  });
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initMainBlogReveal(event.target);
  });
}
